<div class="container-fluid pagecard list-page-main" id="addons-list-page">

    <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
      <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active">
  
        <ng-container [ngbNavItem]="1">
          <a ngbNavLink routerLink="/merchants">{{'Active' | translate | async }}</a>
        </ng-container>
  
        <ng-container [ngbNavItem]="2">
          <a ngbNavLink routerLink="/merchants/merchant-archived">{{'Archived' | translate | async }}</a>
        </ng-container>
  
        <ng-container [ngbNavItem]="3">
        <a ngbNavLink routerLink="/merchants/merchant-onboard">{{'New Onboard' | translate | async }}</a>
        </ng-container>
  
        <ng-container [ngbNavItem]="4">
          <a ngbNavLink routerLink="/merchants/merchant-internal">{{'Internal' | translate | async }}</a>
        </ng-container>
        <ng-container [ngbNavItem]="5">
          <a ngbNavLink routerLink="/merchants/quick-actions">{{'Quick Actions' | translate | async }}</a>
          <div class="container-fluid" style="border-top: 3px solid #dee2e6" *ngIf="f">
            <form [formGroup]="businessForm" (ngSubmit)="onSubmit()">
                <div class="card" formGroupName="businessFormInfoData">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <!-- Account Holder IDs -->
                                <div class="form-layout">
                                    <div class="label-column">
                                        <label class="form-label">Adyen Account Holder ID*</label>
                                    </div>
                                    <div class="input-column">
                                        <div formArrayName="accountHolderIds">
                                            <div *ngFor="let accountHolder of accountHolderControls; let i=index" class="input-row">
                                                <input type="text" 
                                                    class="form-control" 
                                                    [id]="'accountHolder' + i" 
                                                    [formControlName]="i" 
                                                    placeholder="Enter Account Holder ID" 
                                                    (keydown.enter)="$event.preventDefault()"
                                                    [ngClass]="{'is-invalid': (accountHolder.invalid && isSubmitted) || (accountHolder.invalid && accountHolder.touched)}" />
                                                <button type="button" class="btn-remove" *ngIf="i > 0" (click)="removeAccountHolder(i)">
                                                    <img src="assets/images/Shape (1).png" alt="delete">
                                                </button>
                                                <div *ngIf="(accountHolder.invalid && isSubmitted) || (accountHolder.invalid && accountHolder.touched)" class="error-message">
                                                    Please provide a valid Account Holder ID.
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Add Account Holder Button -->
                                        <button type="button" class="btn btn-link p-0" (click)="addAccountHolder()">
                                            <span class="plus-sign">+</span> Add Account Holder
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <!-- cancel and save button -->
                <div class="form-btn">
                    <div class="d-flex flex-wrap gap-3">
                        <div>
                            <button type="button" class="cancel-btn me-3" (click)="goBack()">Cancel</button>
                        </div>
                        <div>
                            <button type="submit" class="btn btn-dark btn-lg w-auto" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                <span *ngIf="!isLoading">Closed Accounts</span>
                                <span *ngIf="isLoading" class="pl-2">&nbsp;&nbsp;Please wait...</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
          </div>
        </ng-container>
      </nav>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>